import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { EMPTY, catchError, tap } from "rxjs";
import { AuthUser } from "../../shared/interfaces/auth.interface";
import { LoginService } from "../data-access/login.service";
import { clearSession, readSession } from "../../shared/utils/session.util";

type AuthState = {
  user: AuthUser | null;
  loading: boolean;
  error: string | null;
};

const initialState: AuthState = {
  user: readSession()?.user ?? null,
  loading: false,
  error: null,
};

export const AuthStorage = signalStore(
  { providedIn: "root" },
  withState<AuthState>(initialState),
  withMethods((store, loginService = inject(LoginService), router = inject(Router)) => ({
    login(email: string, password: string): void {
      if (store.loading()) {
        return;
      }
      patchState(store, { loading: true, error: null });

      loginService
        .login(email, password)
        .pipe(
          tap((response) => {
            patchState(store, { user: response.user, loading: false });
            void router.navigate(["/admin/dashboard"]);
          }),
          catchError(
            (error: {
              error?: { error?: { reason?: string; message?: { description?: string } } };
            }) => {
              patchState(store, {
                loading: false,
                error:
                  error?.error?.error?.message?.description ??
                  error?.error?.error?.reason ??
                  "Credenciales incorrectas",
              });
              return EMPTY;
            }
          )
        )
        .subscribe();
    },

    logout(): void {
      clearSession();
      patchState(store, { user: null, error: null, loading: false });
      void router.navigate(["/login"]);
    },

    loadFromStorage(): void {
      const session = readSession();
      if (session?.user) {
        patchState(store, { user: session.user });
      }
    },

    clearError(): void {
      patchState(store, { error: null });
    },
  }))
);
